import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {ElementInfoForNavigation} from 'app/shared/model/element-info-for-navigation';
import {BimElement} from 'app/shared/model/bim-element';
import {filter} from 'rxjs/operators';
import {TypeElement} from 'app/shared/model/type-element';

@Injectable({
    providedIn: 'root'
})
export class BimElementStore {

    private readonly currentElementInfo$: BehaviorSubject<ElementInfoForNavigation> = new BehaviorSubject({});

    private readonly currentElement$: BehaviorSubject<BimElement> = new BehaviorSubject(null);

    private readonly refreshCurrentElement$: Subject<true> = new Subject();

    private readonly refreshOuvrages$: Subject<true> = new Subject();

    private readonly refreshElementDetail$: Subject<true> = new Subject();

    private readonly refreshFavoriteColumns$: Subject<true> = new Subject();

    private readonly refreshPersonnes$: Subject<true> = new Subject();

    private readonly loadingState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    setCurrentElementInfo(id: string, typeElement: TypeElement) {
        this.currentElementInfo$.next({id, typeElement});
    }

    unsetCurrentElementInfo() {
        this.currentElementInfo$.next({});
    }

    getCurrentElementInfo(): Observable<ElementInfoForNavigation> {
        return this.currentElementInfo$.asObservable().pipe(
            filter(el => el.id != null && el.typeElement != null)
        );
    }

    getCurrentElementInfoSnapshot(): ElementInfoForNavigation {
        return this.currentElementInfo$.getValue();
    }

    setCurrentElement(element: BimElement) {
        this.currentElement$.next(element);
    }

    unsetCurrentElement() {
        this.currentElement$.next(null);
    }

    getCurrentElement(): Observable<BimElement> {
        return this.currentElement$.asObservable().pipe(
            filter(el => el !== null)
        );
    }

    getCurrentElementSnapshot(): BimElement {
        return this.currentElement$.getValue();
    }

    setLoadingState(value: boolean) {
        this.loadingState.next(value);
    }

    getLoadingState(): Observable<boolean> {
        return this.loadingState.asObservable();
    }

    /**
     * Demande le rafraîchissement de l'élément courant.
     */
    refreshCurrentElement(): void {
        this.refreshCurrentElement$.next(true);
    }

    /**
     * Indique chaque fois qu'un rafraîchissement de l'élément courant est demandé.
     */
    getCurrentElementRefresh(): Observable<true> {
        return this.refreshCurrentElement$.asObservable();
    }

    /**
     * Demande le rafraîchissement des ouvrages.
     */
    refreshOuvrages(): void {
        this.refreshOuvrages$.next(true);
    }

    /**
     * Indique chaque fois qu'un rafraîchissement des ouvrages est demandé.
     */
    getOuvragesRefresh(): Observable<true> {
        return this.refreshOuvrages$.asObservable();
    }

    /**
     * Demande le rafraîchissement de l'élément dont le détail est visualisé.
     */
    refreshElementDetail(): void {
        this.refreshElementDetail$.next(true);
    }

    /**
     * Indique chaque fois qu'un rafraîchissement de l'élément dont le détail est visualisé est demandé.
     */
    getElementDetailRefresh(): Observable<true> {
        return this.refreshElementDetail$.pipe(filter(it => it != null));
    }

    /**
     * Demande le rafraîchissement des colonnes affichées dans le tableau.
     */
    refreshFavoriteColumns(): void {
        this.refreshFavoriteColumns$.next(true);
    }

    /**
     * Indique chaque fois qu'un rafraîchissement des colonnes affichées dans le tableau est demandé.
     */
    getFavoriteColumnsRefresh(): Observable<true> {
        return this.refreshFavoriteColumns$.pipe(filter(it => it != null));
    }


    /**
     * Demande le rafraîchissement des personnes.
     */
    refreshPersonnes(): void {
        this.refreshPersonnes$.next(true);
    }

    /**
     * Indique chaque fois qu'un rafraîchissement des personnes est demandé.
     */
    getPersonnesRefresh(): Observable<true> {
        return this.refreshPersonnes$.pipe(filter(it => it != null));
    }
}
